import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';

import { CellAdapter } from '../cell-adapter.component';

@Component({
  selector: 'lepi-drag-handler-cell',
  template: ` <div class="drag-handler-cell flex items-center" cdkDragHandle>
    <span class="icon-[material-symbols--drag-handle]"></span>
  </div>`,
  standalone: true,
  imports: [CdkDragHandle],
})
export class DragHandlerCell extends CellAdapter { }
